import React from 'react';
import { Card, LockedNotice, Pill, SectionHeader } from './ui';
import { EVIDENCE_META, PROGRAM_NAMES } from '../../pages/journey/journeyApi';
import { ReadinessTrend } from './ReadinessTrend';

const Competencies = ({ list }) => (
  <Card data-testid="competency-progress">
    <p className="font-outfit font-semibold text-[#0b1f4d] mb-1">Competency evidence</p>
    <p className="text-xs text-slate-500 mb-4">Self-reported skills are kept separate from skills demonstrated in your work.</p>
    {list.map((c) => (
      <div key={c.id} className="flex items-center justify-between gap-3 py-2.5 border-t border-slate-100 first:border-0 text-sm" data-testid={`competency-${c.id}`}>
        <span>{c.name}{c.core && <span className="text-[10px] ml-2 text-slate-400 uppercase">core</span>}</span>
        <span className="flex items-center gap-2">{c.best_score && <span className="text-xs text-slate-500">best {c.best_score}/4</span>}
          <Pill className={EVIDENCE_META[c.evidence].cls}>{EVIDENCE_META[c.evidence].label}</Pill></span>
      </div>))}
  </Card>
);

const Timeline = ({ history }) => (
  <Card data-testid="progress-timeline">
    <p className="font-outfit font-semibold text-[#0b1f4d] mb-4">Activity history</p>
    <ol className="space-y-3 border-l-2 border-slate-100 pl-4">
      {[...history].reverse().map((h, i) => (
        <li key={i} className="text-sm relative"><span className="absolute -left-[21px] top-1.5 w-2.5 h-2.5 rounded-full bg-teal-500" />
          {h.event}<span className="block text-xs text-slate-400">{new Date(h.at).toLocaleString('en-IN')}</span></li>))}
    </ol>
  </Card>
);

const Attempts = ({ rows }) => (
  <Card data-testid="progress-attempts">
    <p className="font-outfit font-semibold text-[#0b1f4d] mb-4">Improvement across attempts</p>
    {rows.length === 0 ? <p className="text-sm text-slate-500">No submissions yet.</p> : (
      <div className="space-y-2">{rows.map((r, i) => (
        <div key={i} className="flex items-center gap-3 text-sm"><span className="w-56 truncate text-slate-600" title={r.title}>{r.title} #{r.attempt}</span>
          <div className="flex-1 h-2 rounded-full bg-slate-100"><div className="h-full rounded-full bg-[#0b1f4d]" style={{ width: `${r.score ?? 0}%` }} /></div>
          <span className="w-24 text-right text-xs">{r.score == null ? 'in review' : `${r.score}%`}{r.status === 'validated' ? ' ✓' : ''}</span></div>))}</div>)}
  </Card>
);

export const Progress = ({ data: d }) => (
  <>
    <SectionHeader eyebrow="Demonstrated improvement" title="My Progress" />
    {!d.summary && <LockedNotice testid="progress-locked" title="Mission progress tracking starts after consultation" text="Your Readiness Check results and journey history are shown below." />}
    <div className="grid lg:grid-cols-2 gap-5 mt-5">
      <ReadinessTrend history={d.readiness_history || []} />
      {d.pathways.length > 0 && <Card data-testid="progress-programs">
        <p className="font-outfit font-semibold text-[#0b1f4d] mb-4">Program progress</p>
        {d.pathways.map((p) => <div key={p.program_id} className="mb-3 text-sm"><div className="flex justify-between"><span>{PROGRAM_NAMES[p.program_id]}</span><span className="font-semibold">{p.progress}%</span></div>
          <div className="h-2 rounded-full bg-slate-100 mt-1"><div className="h-full bg-teal-500 rounded-full" style={{ width: `${p.progress}%` }} /></div></div>)}
      </Card>}
      {d.competencies.length > 0 && <Competencies list={d.competencies} />}
      <Attempts rows={d.progress_history} />
      <Timeline history={d.student.history} />
    </div>
  </>
);
